module.exports = __webpack_public_path__ + "static/media/S-WEB-Goal-18.32debacf.png";